import { Component, Vue } from 'vue-property-decorator';

@Component
export default class UserDataMenuMixin extends Vue {
  get user() {
    return this.$store.state.user || {};
  }

  get userData() {
    if (this.user.profile) {
      return {
        email: this.user.profile.email,
        fio: this.$store.getters['user/fio'],
      };
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/userData.ts